import React from 'react';
import { Card, CardContent } from './ui/card';
import { Package, Book, Wrench, Phone } from 'lucide-react';
import { Button } from './ui/button';

const DIYSection = () => {
  const diyFeatures = [
    {
      icon: <Package className="w-8 h-8 text-blue-400" />,
      title: 'Complete Hardware Kits',
      description: 'Premium aluminum tracks, professional-grade LED lights, and all mounting hardware included'
    },
    {
      icon: <Wrench className="w-8 h-8 text-blue-400" />,
      title: 'Control Systems',
      description: 'Smart control boxes with smartphone app integration for easy customization'
    },
    {
      icon: <Book className="w-8 h-8 text-blue-400" />,
      title: 'Installation Guide',
      description: 'Detailed step-by-step instructions and video tutorials for successful installation'
    },
    {
      icon: <Phone className="w-8 h-8 text-blue-400" />,
      title: 'Expert Support',
      description: 'Technical support available throughout your installation process'
    },
    {
      icon: <Package className="w-8 h-8 text-blue-400" />,
      title: 'Custom Aluminum Tracks for Govee Pro',
      description: 'Custom colour-matched 6ft aluminum tracks designed specifically for Govee Pro Outdoor Lights - $29.99 per track. Available in any colour to match your home perfectly.',
      isWide: true
    }
  ];

  const scrollToPricing = () => {
    document.getElementById('pricing').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="diy" className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">Do It Yourself</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Get the professional look with our DIY hardware kits. Purchase premium aluminum tracks, lights, control boxes, and installation hardware to create your own stunning display.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12 max-w-6xl mx-auto">
            {diyFeatures.map((feature, index) => (
              <Card 
                key={index} 
                className={`border-none shadow-lg hover:shadow-xl transition-shadow duration-300 ${
                  feature.isWide ? 'lg:col-span-2' : ''
                }`}
              >
                <CardContent className="p-6">
                  <div className="flex items-start gap-4">
                    <div className="bg-blue-50 p-3 rounded-lg">
                      {feature.icon}
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                      <p className="text-gray-600">{feature.description}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="bg-gray-900 rounded-2xl p-8 md:p-12">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-3xl font-bold text-white mb-4">Why Choose DIY?</h3>
                <ul className="space-y-3 text-gray-200">
                  <li className="flex items-start gap-3">
                    <span className="text-blue-400 font-bold">✓</span>
                    <span>Cost-effective solution with professional-grade materials</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-blue-400 font-bold">✓</span>
                    <span>Complete control over installation timing and design</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-blue-400 font-bold">✓</span>
                    <span>Same 20-year warranty as professional installations</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-blue-400 font-bold">✓</span>
                    <span>Satisfaction of completing your own project</span>
                  </li>
                </ul>
              </div>
              <div className="flex flex-col gap-4">
                <img
                  src="https://images.unsplash.com/photo-1759244565958-6a4f485108a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxwZXJtYW5lbnQlMjBvdXRkb29yJTIwbGlnaHRpbmclMjBob3VzZXxlbnwwfHx8fDE3NjAzOTQwOTZ8MA&ixlib=rb-4.1.0&q=85"
                  alt="DIY Installation Hardware"
                  className="rounded-lg shadow-lg"
                />
                <Button onClick={scrollToPricing} size="lg" className="bg-blue-500 hover:bg-blue-600 text-white font-bold">
                  Request DIY Kit Quote
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DIYSection;
